import { Checkbox } from "antd";
import { ColumnsType } from "antd/lib/table";
import { MenuPage } from "components";
import React, { useState } from "react";
import "./style.scss";

export const ManageNewsletter: React.FC = () => {
	const [usersWithAccess, setUsersWithAccess] = useState<any[]>([]);

	const columns: ColumnsType<any> = [
		{
			title: "E-mail",
			dataIndex: "email",
			key: "email",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "20%",
				};
			},
		},
		{
			title: "IP",
			dataIndex: "ip",
			key: "ip",
			render: (text, record) => (
				<p style={{ margin: 0 }}>{text ? text : "-"}</p>
			),
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			onCell: () => {
				return {
					width: "15%",
				};
			},
		},
		{
			title: "Acesso ao newsletter",
			key: "start_access",
			render: (_, record) => (
				<div
					style={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Checkbox
						checked={usersWithAccess.includes(_.email)}
						onChange={(e) => {
							if (e.target.checked) {
								setUsersWithAccess((prevState) => {
									if (prevState.includes(_.email)) {
										return prevState;
									}
									return [...prevState, _.email];
								});
								return;
							}
							setUsersWithAccess((prevState) =>
								prevState.filter((itens) => itens !== _.email)
							);
						}}
					/>
				</div>
			),
			onCell: () => {
				return {
					width: "10%",
				};
			},
		},
	];

	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.newsletters;
	}

	return (
		<div className="newsletter">
			<MenuPage 
				title="Newsletter" 
				tableColumns={columns} 
				sourceDataUrl={'/newsletters'}  
				getDataFromResponse={getTableDataFromResponse}
				searchPlaceholder="Busque por email"
				showAddButton={false}
			/>
		</div>
	);
};
